import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { UPLOAD_SOURCES } from '@cld/upload-widget';
import t from 'common/i18n';
import { selectLocation } from 'root/selectors';
import RouteWithSubRoutes from 'root/components/RouteWithSubRoutes';
import TabHeader from 'root/components/TabHeader';
import Progress from 'root/components/Progress/Progress';
import TabPanel from 'tabs/hocs/TabPanel';
import TabFooter from 'root/components/TabFooter';
import ServiceLoginIntro from 'root/components/ServiceLoginIntro';
import { clearTabSelectionOnNewBatch } from '../common/utils';
import consts from './data/consts';
import getNavItems from './routes/navItems';
import { selectContextItems, selectExtFacebookAppId, selectTabData } from './selectors';
import bindActions, { types as ats } from './actions';
import ContextPhotos from './components/ContextPhotos';
import AlbumBar from './components/AlbumBar';
import SVG_ICONS from '~/assets/icons/icons';

import './FacebookTab.scss';

const isFbConnected = (auth) => auth && auth.status === consts.CONNECTED;

export class FacebookTab extends Component {
  componentDidMount() {
    this.props.actions[ats.DO_REQUEST_FB_STATUS]({ externalAppId: this.props.extAppId });
  }

  componentDidUpdate(prevProps) {
    clearTabSelectionOnNewBatch(this.props, prevProps, this.props.actions[ats.CLEAR_ALL_SELECTION]); // clear the selection only when batch successfully started
  }

  onUploadButtonClick = () => {
    this.props.addToUploadQueue({
      files: this.props.contextData.selected,
    });
  };

  onClearSelectedClick = () => {
    this.props.actions[ats.CLEAR_IMAGE_SELECTION](this.props.tabData.currentContext);
  };

  onNoAuthActionClick = () => {
    this.props.actions[ats.DO_LOGIN]();
  };

  onUserLogout = () => {
    this.props.actions[ats.DO_LOGOUT]();
  };

  onAlbumBack = () => {
    this.props.history.goBack();
  };

  renderSubRoutes() {
    return this.props.routes.map((r) => <RouteWithSubRoutes key={`fb_route_${r.path}`} {...r} isMultiple={this.props.tabData.isMultiple} />);
  }

  renderDefaultRoute() {
    return <Route render={() => <ContextPhotos isMultiple={this.props.tabData.isMultiple} context={consts.CONTEXTS.UPLOADED_PHOTOS} />} />;
  }

  renderTabContent() {
    let content;

    if (self.FB) {
      if (isFbConnected(this.props.tabData.auth)) {
        content = (
          <div className="tab-authed flex flex-column" data-test="tab-authed">
            <TabHeader source={UPLOAD_SOURCES.FACEBOOK} userName={this.props.tabData.userName} navItems={getNavItems()} onLogout={this.onUserLogout}>
              {this.renderHeaderContent()}
            </TabHeader>

            <Switch>
              {this.renderSubRoutes()}
              {this.renderDefaultRoute()}
            </Switch>
          </div>
        );
      } else {
        content = (
          <ServiceLoginIntro
            key="fb_login_intro"
            title={t('facebook.no_auth_title')}
            actionTitle={t('facebook.no_auth_action')}
            statement={t('facebook.no_auth_statement')}
            btnClass="btn-fb"
            dataTest="connect-to-facebook-btn"
            btnIcon={SVG_ICONS.FACEBOOK}
            actionHandler={this.onNoAuthActionClick}
          />
        );
      }
    } else {
      content = <Progress size={42} overlay />;
    }

    return content;
  }

  renderHeaderContent() {
    const currentRoute = this.props.location.pathname.split('/').filter((item) => item)[1];

    return currentRoute && currentRoute === 'album' ? <AlbumBar albumData={this.props.tabData.album || {}} onGoBack={this.onAlbumBack} /> : null;
  }

  renderFooter() {
    const ctxData = this.props.contextData;
    const selectionCount = ctxData && ctxData.selected && ctxData.selected.length;

    return (
      <TabFooter
        showSelection
        selectionCount={selectionCount}
        clearSelectionHandler={this.onClearSelectedClick}
        uploadButtonHandler={this.onUploadButtonClick}
      />
    );
  }

  render() {
    return (
      <div className={`facebook-block ${isFbConnected(this.props.tabData.auth) ? 'user-active' : ''}`}>
        <div className="holder large-thin-menu-holder">{this.renderTabContent()}</div>

        {this.renderFooter()}
      </div>
    );
  }
}

export default TabPanel({
  id: UPLOAD_SOURCES.FACEBOOK,
})(
  connect(
    createStructuredSelector({
      tabData: selectTabData,
      contextData: selectContextItems,
      location: selectLocation,
      extAppId: selectExtFacebookAppId,
    }),
    (dispatch) => ({
      actions: bindActions(dispatch),
    })
  )(withRouter(FacebookTab))
);
